import { create } from 'zustand'
import { Kpi, KpiEvaluationResult, EvaluateKpiDto } from '@/types'
import { kpisService } from '@/services/kpis.service'

interface KpisState {
  kpis: Kpi[]
  isLoading: boolean
  isInitialized: boolean
  fetchKpis: () => Promise<void>
  getKpiById: (id: string) => Kpi | undefined
  evaluateKpi: (id: string, evaluateKpiDto?: EvaluateKpiDto) => Promise<KpiEvaluationResult[]>
}

export const useKpisStore = create<KpisState>((set, get) => ({
  kpis: [],
  isLoading: false,
  isInitialized: false,

  fetchKpis: async () => {
    if (get().isInitialized) {
      return
    }

    set({ isLoading: true })
    try {
      const data = await kpisService.getAll()
      set({ kpis: data, isInitialized: true })
    } catch (error) {
      console.error('Error fetching KPIs:', error)
      throw error
    } finally {
      set({ isLoading: false })
    }
  },

  getKpiById: (id: string) => {
    return get().kpis.find((kpi) => kpi._id === id)
  },

  evaluateKpi: async (id: string, evaluateKpiDto?: EvaluateKpiDto) => {
    try {
      const results = await kpisService.evaluate(id, evaluateKpiDto)
      return results
    } catch (error) {
      console.error('Error evaluating KPI:', error)
      throw error
    }
  },
}))

